// Account-level helpers. The empowered ID is a unique, human-friendly account ID
// (6 chars: first alphabetic, rest alphanumeric) minted server-side at first
// sign-in and stable thereafter.
import { fbAuth } from './firebase';

export async function ensureEmpoweredId(): Promise<string | null> {
  const u = fbAuth.currentUser;
  if (!u) return null;
  try {
    const token = await u.getIdToken();
    const res = await fetch('/api/empowered-id', {
      method: 'POST',
      headers: { authorization: `Bearer ${token}`, 'content-type': 'application/json' },
      body: '{}',
    });
    const d: { ok?: boolean; empoweredId?: string } = await res.json().catch(() => ({}));
    return res.ok && d.ok ? d.empoweredId ?? null : null;
  } catch (_) {
    return null;
  }
}
